module.exports = __webpack_public_path__ + "img/experiencia-de-usuario.c04ffaef.png";